<section [ngClass]="dynamicClass">
  <div class="eq-container">
    <div class="eq-flex eq-flex-col eq-gap-[44px]">
      <div class="eq-flex eq-flex-col eq-gap-y-[21px]">
        <h2 *ngIf="rendering.fields?.Title?.value" class="eq-w-full eq-text-heading2-m eq-font-bold eq-text-blue-darkBlue lg:eq-text-heading2">
          {{ rendering.fields?.Title?.value }}
        </h2>
        <div *ngIf="rendering.fields?.Subtitle?.value" class="eq-text-body-m eq-text-black-natural-60 lg:eq-text-body lg:eq-max-w-[710px]">
          {{ rendering.fields?.Subtitle?.value }}
        </div>
      </div>
      <div *ngIf="rendering.fields?.GroupItems.length > 0" class="">
        <div class="eq-swiper-filter">
          <div class="swiper-wrapper !eq-w-fit lg:eq-gap-5 lg:eq-flex-wrap lg:!eq-translate-x-0">
            <ng-container *ngFor="let item of rendering.fields?.GroupItems;">
              <div class="swiper-slide !eq-w-fit eq-text-tabs-m eq-font-bold eq-whitespace-nowrap lg:eq-text-tabs">
                <div class="eq-tab eq-flex eq-justify-center eq-items-center hover:eq-decoration-1"
                  (click)="createGroupList(item);"
                  [ngClass]="item?.fields?.Title?.value == selectedGroup?.fields?.Title.value ? 'eq-underline eq-decoration-red-brandRed eq-decoration-[3px] eq-underline-offset-8':'' ">
                  {{item?.fields?.Title?.value}}
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="rendering.fields?.GroupItems.length > 0" class="eq-cards-grid eq-grid eq-grid-cols-1 eq-gap-[20px] md:eq-grid-cols-2 lg:eq-grid-cols-1 xl:eq-grid-cols-2">
        <ng-container *ngFor="let card of groupList">
          <app-card-module class="eq-w-[344px] lg:eq-w-[464px] md:eq-mx-auto" [cardData]="card"></app-card-module>
        </ng-container>
      </div>
      <div *ngIf="showMoreBtn" class="eq-flex eq-justify-center">
        <button type="button" class="eq-btn eq-btn-secondary" (click)="showMore()">{{'See more' | translate}}</button>
      </div>
    </div>
  </div>
</section>